/** biome-ignore-all lint/suspicious/noExplicitAny: TODO: fix */
import type { RoutingGuideShortInfo } from '@/views/screens/RoutingGuide/types';

import { convertDateUTCToUserLocal } from '../../utilz/dates';
import { DEFAULT_STORE_OBJECT } from '../constants';
import type { DefaultStoreObject } from '../types';
import RoutingGuideTypes from './RoutingGuideTypes';
import getroutingGuidelistBySearch from './requestPayload/getRoutingGuideList';

export interface RoutingGuideState extends Record<string, any> {
  selectedRoutingGuides: RoutingGuideShortInfo['routingGuideId'][];
  routingGuideDetails: DefaultStoreObject<RoutingGuideShortInfo[]> & {
    req: {
      PageSize: number;
      PageNo: number;
    };
    totalCount: number;
  };
  isNXPUserSelectedAll: boolean;
}

const NXP_user_request = {
  ClientCode: '',
  CompanyName: '',
  PageNo: 1,
  PageSize: 10,
  UserName: '',
  UserStatus: '',
  UserTypeId: '',
};

const INITIAL_FILTER_PARAMS = [
  { type: 'CountryCode', value: null },
  { type: 'TransportationGroup', value: null },
  { type: 'TransportationMode', value: null },
  { type: 'UserId', value: null },
  { type: 'CarrierId', value: null },
  { type: 'Email', value: null },
  { type: 'PageNumber', value: 1 },
];

const initialState: RoutingGuideState = {
  allUsersNames: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },
  clientCodeData: [],
  createdRoutingGuideId: null,
  createRoutingGuide: {},
  createRoutingGuideUser: {},
  deleteNxpUser: {},
  guidesListSearchParams: INITIAL_FILTER_PARAMS,
  isNXPUserSelectedAll: false,
  npxUserTypesData: {
    data: [],
  },
  nxpHomeContent: {},
  nxpUpdateHomeContent: {},
  nxpUserSearchList: {
    data: [],
    request: { ...NXP_user_request },
  },
  routingGuideCarriers: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },
  routingGuideCollaborators: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },
  routingGuideDetails: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    req: {
      ...getroutingGuidelistBySearch,
    },
    totalCount: 0,
  },
  routingSpotFilteredData: [],
  routingSpotFilteredDataLoading: false,
  routingSpotFilteredDataTotalCount: 0,
  routingSpotQuoteGuideData: {
    data: {},
  },
  selectedRoutingGuides: [],
  transportData: [],
};

const RoutingGuideReducer = (state = initialState, { type, payload }: any): RoutingGuideState => {
  switch (type) {
    case RoutingGuideTypes.CLIENT_CODE_DATA: {
      return {
        ...state,
        clientCodeData: payload,
      };
    }

    case RoutingGuideTypes.NPX_USER_TYPES_DATA: {
      return {
        ...state,
        npxUserTypesData: {
          data: payload,
        },
      };
    }

    case RoutingGuideTypes.SET_TRANSPORT_DATA: {
      return {
        ...state,
        transportData: payload,
      };
    }

    case RoutingGuideTypes.GET_ROUTING_GUIDE_LIST_CLEAR_REQ: {
      return {
        ...state,
        routingGuideDetails: {
          ...DEFAULT_STORE_OBJECT,
          ...state.routingGuideDetails,
          data: [],
          progressing: true,
          req: {
            ...getroutingGuidelistBySearch,
          },
        },
      };
    }

    case RoutingGuideTypes.GET_ROUTING_GUIDE_LIST: {
      return {
        ...state,
        routingGuideDetails: {
          ...DEFAULT_STORE_OBJECT,
          ...state.routingGuideDetails,
          data: [...(state.routingGuideDetails.data || [])],
          progressing: true,
          req: {
            ...state.routingGuideDetails.req,
            ...payload,
          },
        },
      };
    }

    case RoutingGuideTypes.GET_ROUTING_GUIDE_SUCCESS: {
      return {
        ...state,
        routingGuideDetails: {
          ...DEFAULT_STORE_OBJECT,
          ...state.routingGuideDetails,

          data: [
            ...(state.routingGuideDetails.data || []),
            // @ts-expect-error
            ...payload.data.routingGuideList.map((element) => ({
              ...element,
              createdOn: convertDateUTCToUserLocal(element.createdOn),
              modifiedOn: convertDateUTCToUserLocal(element.modifiedOn),
            })),
          ],
          progressing: false,
          success: true,
          totalCount: payload.data.totalCount,
        },
      };
    }

    case RoutingGuideTypes.GET_ROUTING_GUIDE_DATA_RESET: {
      return {
        ...state,
        routingGuideDetails: {
          ...DEFAULT_STORE_OBJECT,
          ...state.routingGuideDetails,
          data: [],
          error: false,
          req: {
            ...state.routingGuideDetails.req,
          },
          success: false,
        },
      };
    }

    case RoutingGuideTypes.DELETE_ROUTING_GUIDES_PROGRESS: {
      return {
        ...state,
        deleteRoutingGuides: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          progressing: true,
        },
      };
    }

    case RoutingGuideTypes.DELETE_ROUTING_GUIDES_SUCCESS: {
      return {
        ...state,
        deleteRoutingGuides: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }

    case RoutingGuideTypes.DELETE_ROUTING_GUIDES_ERROR: {
      return {
        ...state,
        deleteRoutingGuides: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    case RoutingGuideTypes.SET_SELECTED_ROUTING_GUIDE: {
      return {
        ...state,
        selectedRoutingGuides: payload,
      };
    }

    case RoutingGuideTypes.CREATE_ROUTING_GUIDE_PROGRESS: {
      return {
        ...state,
        createRoutingGuide: {
          ...state.createRoutingGuide,
          progressing: true,
        },
      };
    }

    case RoutingGuideTypes.CREATE_ROUTING_GUIDE_SUCCESS: {
      return {
        ...state,
        createRoutingGuide: {
          ...state.createRoutingGuide,
          data: payload.data,
          progressing: false,
          success: true,
        },
      };
    }

    case RoutingGuideTypes.CREATE_ROUTING_GUIDE_CLEAR: {
      return {
        ...state,
        createRoutingGuide: {
          ...state.createRoutingGuide,
          data: {},
          progressing: false,
          success: false,
        },
      };
    }

    case RoutingGuideTypes.CREATE_ROUTING_GUIDE_USER_PROGRESS: {
      return {
        ...state,
        createRoutingGuideUser: {
          ...state.createRoutingGuideUser,
          progressing: true,
        },
      };
    }

    case RoutingGuideTypes.CREATE_ROUTING_GUIDE_USER_SUCCESS: {
      return {
        ...state,
        createRoutingGuideUser: {
          ...state.createRoutingGuideUser,
          data: payload.data,
          progressing: false,
          success: true,
        },
      };
    }

    case RoutingGuideTypes.CREATE_ROUTING_GUIDE_USER_CLEAR: {
      return {
        ...state,
        createRoutingGuideUser: {
          ...state.createRoutingGuideUser,
          data: {},
          progressing: false,
          success: false,
        },
      };
    }

    case RoutingGuideTypes.GET_CONTENT_NXP_ROUTING_GUIDE: {
      return {
        ...state,
        nxpHomeContent: {
          ...state.nxpHomeContent,
          data: {},
          progressing: true,
        },
      };
    }

    case RoutingGuideTypes.GET_CONTENT_NXP_ROUTING_GUIDE_SUCCESS: {
      return {
        ...state,
        nxpHomeContent: {
          ...state.nxpHomeContent,
          data: payload.data,
          progressing: false,
          success: true,
        },
      };
    }

    case RoutingGuideTypes.GET_CONTENT_NXP_ROUTING_GUIDE_ERROR: {
      return {
        ...state,
        nxpHomeContent: {
          ...state.nxpHomeContent,
          data: {},
          progressing: false,
          success: false,
        },
      };
    }

    case RoutingGuideTypes.UPDATE_CONTENT_NXP_ROUTING_GUIDE: {
      return {
        ...state,
        nxpUpdateHomeContent: {
          ...state.nxpUpdateHomeContent,
          data: {},
          progressing: true,
        },
      };
    }

    case RoutingGuideTypes.UPDATE_CONTENT_NXP_ROUTING_GUIDE_SUCCESS: {
      return {
        ...state,
        nxpUpdateHomeContent: {
          ...state.nxpUpdateHomeContent,
          data: payload.data,
          progressing: false,
          success: true,
        },
      };
    }

    case RoutingGuideTypes.UPDATE_CONTENT_NXP_ROUTING_GUIDE_ERROR: {
      return {
        ...state,
        nxpUpdateHomeContent: {
          ...state.nxpUpdateHomeContent,
          data: {},
          progressing: false,
          success: false,
        },
      };
    }

    case RoutingGuideTypes.GET_NXP_USER_SEARCH_INPROGRESS: {
      return {
        ...state,
        nxpUserSearchList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.nxpUserSearchList,
          progressing: true,
          request: {
            ...state.nxpUserSearchList.request,
            ...payload,
          },
        },
      };
    }

    case RoutingGuideTypes.GET_NXP_USER_SEARCH_SUCCESS: {
      // @ts-expect-error
      payload?.data?.data?.forEach((element) => {
        element.isChecked = state.isNXPUserSelectedAll;
      });
      return {
        ...state,
        nxpUserSearchList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.nxpUserSearchList,
          // biome-ignore lint/correctness/noUnsafeOptionalChaining: TODO: fix
          data: [...state.nxpUserSearchList.data, ...payload?.data?.data],
          error: false,
          progressing: false,
          success: true,
          totalCount: payload?.data?.totalRecords,
        },
      };
    }

    case RoutingGuideTypes.GET_NXP_USER_SEARCH_FAIL: {
      return {
        ...state,
        nxpUserSearchList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.nxpUserSearchList,
          error: true,
          progressing: false,
          success: false,
        },
      };
    }

    case RoutingGuideTypes.GET_NXP_USER_SEARCH_RESET_REQUEST: {
      return {
        ...state,
        nxpUserSearchList: {
          ...state.nxpUserSearchList,
          request: {
            ...NXP_user_request,
          },
        },
      };
    }

    case RoutingGuideTypes.GET_NXP_USER_SEARCH_CLEAR_DATA: {
      return {
        ...state,
        nxpUserSearchList: {
          ...state.nxpUserSearchList,
          data: [],
        },
      };
    }

    case RoutingGuideTypes.GET_NXP_USER_SELECTED_RECORD: {
      let isSelectedAll = false;
      const dataList = [...state.nxpUserSearchList.data];
      if (payload === true || payload === false) {
        isSelectedAll = payload;
        dataList.forEach((item) => {
          item.isChecked = payload;
        });
      } else {
        const foundObject = dataList.find((obj) => obj.userId === payload);
        if (foundObject) {
          foundObject.isChecked = !foundObject.isChecked;
        }
        const findCheckedItem = dataList.filter((i) => i.isChecked === true);
        if (findCheckedItem.length === dataList.length) {
          isSelectedAll = true;
        }
      }

      return {
        ...state,
        isNXPUserSelectedAll: isSelectedAll,
        nxpUserSearchList: {
          ...state.nxpUserSearchList,
          data: dataList,
        },
      };
    }

    case RoutingGuideTypes.DELETE_NXP_USER: {
      return {
        ...state,
        deleteNxpUser: {
          ...state.deleteNxpUser,
          progressing: true,
        },
      };
    }

    case RoutingGuideTypes.DELETE_NXP_USER_SUCCESS: {
      return {
        ...state,
        deleteNxpUser: {
          ...state.deleteNxpUser,
          data: payload.data,
          progressing: false,
          success: true,
        },
      };
    }

    case RoutingGuideTypes.DELETE_NXP_USER_FAIL: {
      return {
        ...state,
        deleteNxpUser: {
          ...state.deleteNxpUser,
          data: [],
          error: true,
          progressing: false,
          success: false,
        },
      };
    }

    case RoutingGuideTypes.SET_ROUTING_GUIDE_SEARCH_PARAMS: {
      let updatedParams = [...state.guidesListSearchParams];
      const shouldOverwrite = updatedParams.some((param) => param.type === payload.type);

      if (shouldOverwrite) {
        updatedParams = updatedParams.map((param) => {
          if (param.type === payload.type) {
            return {
              ...param,
              value: payload.value,
            };
          }
          return param;
        });
      } else {
        updatedParams.push(payload);
      }

      return {
        ...state,
        guidesListSearchParams: updatedParams,
      };
    }
    case RoutingGuideTypes.RESET_ROUTING_GUIDE_SEARCH_PARAMS: {
      return {
        ...state,
        guidesListSearchParams: [],
      };
    }

    case RoutingGuideTypes.SET_ROUTING_SPOT_FILTERED_DATA: {
      return {
        ...state,
        routingSpotFilteredData: payload.routingGuides || [],
        routingSpotFilteredDataLoading: payload.isLoading,
        routingSpotFilteredDataTotalCount: payload.totalCount || 0,
      };
    }

    case RoutingGuideTypes.GET_CARRIERS_ROUTING_GUIDE_PROGRESS: {
      return {
        ...state,
        routingGuideCarriers: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          progressing: true,
        },
      };
    }

    case RoutingGuideTypes.GET_COLLABORATORS_ROUTING_GUIDE_PROGRESS: {
      return {
        ...state,
        routingGuideCollaborators: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          progressing: true,
        },
      };
    }

    case RoutingGuideTypes.GET_CARRIERS_ROUTING_GUIDE_SUCCESS: {
      return {
        ...state,
        routingGuideCarriers: {
          ...state.routingGuideCarriers,
          progressing: false,
          success: true,
          ...payload,
        },
      };
    }

    case RoutingGuideTypes.GET_COLLABORATORS_ROUTING_GUIDE_SUCCESS: {
      return {
        ...state,
        routingGuideCollaborators: {
          ...state.routingGuideCollaborators,
          progressing: false,
          success: true,
          ...payload,
        },
      };
    }

    case RoutingGuideTypes.GET_ALL_USERS_NAME_SUCCESS: {
      return {
        ...state,
        allUsersNames: {
          ...state.allUsersNames,
          progressing: false,
          success: true,
          ...payload,
        },
      };
    }

    case RoutingGuideTypes.GET_ALL_USERS_NAME_PROGRESS: {
      return {
        ...state,
        allUsersNames: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          progressing: true,
        },
      };
    }

    case RoutingGuideTypes.GET_CARRIERS_ROUTING_GUIDE_ERROR: {
      return {
        ...state,
        routingGuideCarriers: {
          ...state.routingGuideCarriers,
          data: [],
          error: true,
          progressing: false,
          ...payload,
        },
      };
    }

    case RoutingGuideTypes.ADD_ROUTING_GUIDE_HEADER: {
      return {
        ...state,
        createdRoutingGuideId: payload,
      };
    }

    default:
      return state;
  }
};
// biome-ignore lint/style/noDefaultExport: TODO: fix
export default RoutingGuideReducer;
